<template>
    <svg aria-hidden="true" focusable="false" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22" cy="22" r="22" fill="white" />
        <path
            d="M29.275 28.75H14.6C14.0399 28.75 13.7599 28.75 13.546 28.641C13.3578 28.5451 13.2049 28.3922 13.109 28.204C13 27.9901 13 27.7101 13 27.15V17.975C13 17.4149 13 17.1349 13.109 16.921C13.2049 16.7328 13.3578 16.5799 13.546 16.484C13.7599 16.375 14.0399 16.375 14.6 16.375H18.5L19.1875 15H24.686L25.3735 16.375H29.275C29.8351 16.375 30.1151 16.375 30.329 16.484C30.5172 16.5799 30.6701 16.7328 30.766 16.921C30.875 17.1349 30.875 17.4149 30.875 17.975V27.15C30.875 27.7101 30.875 27.9901 30.766 28.204C30.6701 28.3922 30.5172 28.5451 30.329 28.641C30.1151 28.75 29.8351 28.75 29.275 28.75Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <circle cx="21.9375" cy="22.5625" r="3.4375" stroke="black" />
    </svg>
</template>
